import React from 'react';
import { Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BRAND } from '../../theme/brandTokens';

const BookingWaitlistCta = ({ onJoin, sx }) => {
  const { t } = useTranslation();

  return (
    <Typography variant="body2" color="text.secondary" sx={{ mt: 2, mb: { xs: 1, sm: 0 }, textAlign: 'center', px: { xs: 0.5, sm: 0 }, ...sx }}>
      {t('customer.appointments.booking.waitlist.prompt')}{' '}
      <Link
        component="button"
        type="button"
        onClick={onJoin}
        sx={{
          color: BRAND.accentText,
          fontWeight: 700,
          textDecoration: 'underline',
          cursor: 'pointer',
          verticalAlign: 'baseline',
        }}
      >
        {t('customer.appointments.booking.waitlist.cta')}
      </Link>
    </Typography>
  );
};

export default BookingWaitlistCta;
